// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Footer_mainWrapper__4Lp1G","footer":"Footer_footer__TL9Uz","text":"Footer_text__Ws8Gy","disclaimer":"Footer_disclaimer__-6AQZ"};